import getConfig from 'next/config';
import React, { FC, useMemo } from 'react';

import { formatSeasonFromString } from 'shared/helpers/product';

export const Season: FC<{ formattedSeason: string }> = ({ formattedSeason }) => {
  const { publicRuntimeConfig } = getConfig();
  const { newSeasons: newSeasonsStr } = publicRuntimeConfig;
  const newSeasons = useMemo(() => newSeasonsStr.split(',') || [], []);

  const isLatestSeason = useMemo(() => {
    const newSeasonsFormatted = (newSeasons as string[]).map(formatSeasonFromString);
    return newSeasonsFormatted.includes(formattedSeason);
  }, [newSeasons, formattedSeason]);

  return (
    <>
      {isLatestSeason && 'New season '}
      {formattedSeason}
    </>
  );
};
